<template>
    <div :class="$style.wrapper">
        <div :class="$style.part">
            <h1>当前头像</h1>
            <!--<img src="../../assets/header/avatar.png" alt=""/>-->
            <img :src="userInfo&&userInfo.avatar" alt=""/>
            <el-button :loading="btnLoading" @click="handleUpload" :class="$style.submitBtn">
                提交保存
            </el-button>
        </div>
        <div :class="$style.part">
            <h1>修改头像</h1>
            <img v-if="imgBase64" :src="imgBase64" alt=""/>
            <img v-else src="../../assets/header/default_avatar.png" alt=""/>
            <el-upload
                :http-request="handleChange"
                action=""
                accept="image/*"
                :show-file-list="false"
                :before-upload="beforeUpload"
            >
                <el-button size="mini">上传头像</el-button>
                <div style="font-size:12px;color:#9ca2ad;" slot="tip">(只能上传jpg/png文件，且不超过500kb)</div>
            </el-upload>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { postUserInfo } from '../../stores/api';

    export default {
        data () {
            return {
                btnLoading: false,
                imgBase64: ''
            };
        },
        methods: {
            beforeUpload (file) {
                const isLt500K = file.size / 1024 / 1024 < 0.5;
                if (!isLt500K) {
                    this.$message.error('请上传小于500Kb的图片!');
                }
                return isLt500K;
            },
            handleChange (info) {
                let self = this;
                const reader = new FileReader();
                reader.addEventListener('load', () => (self.imgBase64 = reader.result));
                reader.readAsDataURL(info.file);
            },
            handleUpload () {
                if (!this.imgBase64) {
                    this.$notify.error({
                        title: '操作失败',
                        message: '请选择图片'
                    });
                } else {
                    this.btnLoading = true;
                    postUserInfo({avatar: this.imgBase64.split(',')[1]}).then(async () => {
                        await this.getUserInfo();
                        this.$notify.success({
                            title: '操作成功',
                            message: '成功修改头像'
                        });
                        this.imgBase64 = '';
                    }).catch(err => {
                        this.$notify.error({
                            title: '操作失败',
                            message: err.message
                        });
                    }).then(() => {
                        this.btnLoading = false;
                    });
                }
            },
            ...mapActions(['getUserInfo']),
        },
        computed: {
            ...mapState(['userInfo']),
        }
    };
</script>

<style lang="less" module>
    @import "common";

    .wrapper {
        display: flex;
        padding: 20px 0;
        .part {
            margin: 0 30px;
            & > h1 {
                font-size: 20px;
                color: #636975;
            }
            & > img {
                background-color: #fff;
                border: 1px solid #c0ccda;
                margin-bottom: 20px;
                /*background: #d8d8d8;*/
                border-radius: 4px;
                width: 200px;
                height: 200px;
            }
        }
        .submitBtn {
            display: block;
            margin-top: 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserInfo/Avatar.vue